import React from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Link,
  Stack,
} from '@mui/material';
import styled from '@emotion/styled';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Mail';

const FormTopStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

const FormImageLeftStyled = styled(Box)(({}) => ({
  background: 'gray',
  width: 100,
  height: 100,
  borderRadius: 100,
  overflow: 'hidden',
  marginRight: 20,
}));

const FromTestRightStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));

const FormContactRowStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
}));

function ContentReadOnly({ data }: any) {
  return (
    <>
      {data.contentBlocks.map(
        (e: { type: string; props: any; content: string; _id: string }) => {
          switch (e.type) {
            case 'title':
              return (
                <Typography variant='h5' {...e.props}>
                  {e.content}
                </Typography>
              );
            case 'paragraph':
              return (
                <Typography variant='body1' {...e.props}>
                  {e.content}
                </Typography>
              );
            case 'image':
              return (
                <Box width={'100px'}>
                  <img width={'100%'} {...e.props} />
                </Box>
              );
            case 'link':
              return <Link {...e.props} />;
            case 'map':
              return (
                <Stack>
                  <Typography variant='caption'>[Map]</Typography>
                  <Typography variant='caption'>lng{e.props.lng}</Typography>
                  <Typography variant='caption'>lat{e.props.lat}</Typography>
                  <Typography variant='caption'>zoom{e.props.zoom}</Typography>
                </Stack>
              );
            case 'social':
              return (
                <Stack>
                  <Typography variant='caption'>
                    facebook:{e.props.facebook}{' '}
                  </Typography>
                  <Typography variant='caption'>
                    twitter:{e.props.twitter}{' '}
                  </Typography>
                  <Typography variant='caption'>
                    instagram:{e.props.instagram}{' '}
                  </Typography>
                  <Typography variant='caption'>
                    linkedIn:{e.props.linkedIn}{' '}
                  </Typography>
                  <Typography variant='caption'>
                    snapchat:{e.props.snapchat}{' '}
                  </Typography>
                  <Typography variant='caption'>
                    tiktok:{e.props.tiktok}{' '}
                  </Typography>
                </Stack>
              );
            default:
              return <div>{JSON.stringify(e)}</div>;
          }
        }
      )}
    </>
  );
}

function ContentEdit({ data, setPayload }: any) {
  const onFieldEdit = (e: any) => {
    setPayload({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormImageLeftStyled />
      </Grid>
      <Grid item xs={12}>
        <FormGroup></FormGroup>
      </Grid>
    </Grid>
  );
}

export { ContentReadOnly, ContentEdit };
